var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legal-document',{attrs:{"title":"Публичная оферта","type":"terms"}})}
var staticRenderFns = []

export { render, staticRenderFns }